import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, Form } from 'reactstrap'
import resolveShipLabel from './resolveShipLabel'

class ShipSearch extends React.Component {
    state = {
        barcode: '',
        labelPreview: null,        // dataURL (label vẽ) / url (label thật); null = đơn chưa có label
        labelPreviewLoaded: false, // đã resolve xong preview cho đơn hiện tại chưa
    }

    componentDidMount() {
        this._isMounted = true
        if (this.props.item) this._loadLabelPreview(this.props.item)
    }

    componentDidUpdate(prevProps) {
        // item đổi (scan đơn mới / regenerate label / reset) → resolve lại preview
        if (prevProps.item !== this.props.item) {
            if (this.props.item) {
                this._loadLabelPreview(this.props.item)
            } else {
                this.setState({ labelPreview: null, labelPreviewLoaded: false })
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    _loadLabelPreview = async (item) => {
        const token = (item && (item._id || item.barcodeNumber)) || null
        this._previewToken = token
        this.setState({ labelPreview: null, labelPreviewLoaded: false })

        try {
            const labelPreview = await resolveShipLabel(item)
            // bỏ qua kết quả cũ nếu đã scan đơn khác trong lúc đang vẽ
            if (this._isMounted && this._previewToken === token) {
                this.setState({ labelPreview, labelPreviewLoaded: true })
            }
        } catch (e) {
            if (this._isMounted && this._previewToken === token) {
                this.setState({ labelPreview: null, labelPreviewLoaded: true })
            }
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const { onSubmit } = this.props
        const { barcode } = this.state
        const vBarcode = (barcode || '').trim()

        if (!vBarcode) return false

        this.setState({
            barcode: ''
        }, () => {
            typeof onSubmit === 'function' && onSubmit(vBarcode)
        })
    }

    _handleChangeInput = (e) => {
        const { value } = e.target

        this.setState({
            barcode: value,
        })
    }

    // Khi scan item đầu tiên của đơn:
    // - Đơn có label (label thật hoặc label hệ thống vẽ được) → hiện hình ảnh label.
    // - Đơn chưa có label → hiện text "Chưa có label" nhấp nháy.
    _renderLabelPreview = () => {
        const { item } = this.props
        const { labelPreview, labelPreviewLoaded } = this.state

        if (!item || !labelPreviewLoaded) return null

        if (!labelPreview) {
            return <div className="LabelWarning blink">Chưa có label</div>
        }

        const isPdf = /\.pdf(\?|$)/i.test(labelPreview)

        return (
            <div className="LabelPreview">
                {
                    isPdf
                        ? <iframe title="label-preview" src={labelPreview} />
                        : <img src={labelPreview} alt="label preview" />
                }
            </div>
        )
    }

    render() {
        const { barcode } = this.state
        const { status, item } = this.props
        const { tags = [] } = { ...item }

        return (
            <div className='PrintSearch'>
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline justify-content-start flex-wrap">
                        <h1 className="card-title mr-5">Dán Label - Quét hoặc nhập mã QR</h1>
                        {tags.includes('wood_product') &&
                            <span className="woodTag mr-3">Sản phẩm Gỗ</span>
                        }
                        {tags.includes('made_vn') &&
                            <span className="tagVN mr-3">Made in VN</span>
                        }
                        {tags.includes('photo_requested') &&
                            <span className="photo_request mr-3">CHỤP ẢNH</span>
                        }
                    </div>
                    <CardBody>
                        <div className="d-flex justify-content-between align-items-start">
                            <Form className='d-flex justify-content-center flex-grow-1' onSubmit={this._handleSubmit}>
                                <input
                                    className='InputSearch form-control'
                                    name='barcodeNumber'
                                    value={barcode}
                                    onChange={this._handleChangeInput}
                                    autoFocus
                                />

                                {
                                    !!status &&
                                    <div className="Status">{status}</div>
                                }
                            </Form>

                            {this._renderLabelPreview()}
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

ShipSearch.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    status: PropTypes.string,
}

export default ShipSearch
